import React, {useState} from "react";
import {useDispatch} from "react-redux";
import {PasswordVisibilityIcon} from "../../../icons/PasswordVisibilityIcon";

export const PasswordField = (props) => {
    const dispatch = useDispatch();
    const [isFocused, setIsFocused] = useState(false);
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

    const resetErrorStyles = () => {
        dispatch(props.errorSetter({...props.error, [props.id]: null}))
    }

    return (
        <div className={'form-field-wrapper'}>
            <div className={'form-field-container'}>
                <label htmlFor={props.id} className={'form-label'}>
                    {props.name}
                </label>
                <div className={'password-field-wrapper'}>
                    <input type={isPasswordVisible ? 'text' : 'password'}
                           className={`form-field password ${props.error?.[props.id] ? 'error' : ''}`}
                           id={props.id}
                           name={props.id}
                           value={props.value ?? ''}
                           onChange={(e) => {
                               props.onChange(e);
                               resetErrorStyles();
                           }}
                           placeholder={!isFocused ? props.placeholder : ''}
                           onFocus={() => setIsFocused(true)}
                           onBlur={() => setIsFocused(false)}
                    />
                    <PasswordVisibilityIcon style={{marginLeft: '-30px'}}
                                            toggleVisibility={() => setIsPasswordVisible(!isPasswordVisible)}/>
                    {props.error?.[props.id] && <div className={'validation-msg'}>{props.error[props.id]}</div>}
                </div>
            </div>
        </div>
    );
}